module.exports = __webpack_public_path__ + "static/media/bulb.db7ba58c.svg";